import React from 'react';
import ReactDOM from 'react-dom';

import FormItemConst from '../../formItem/FormItemConst';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';

export default class DialogFieldLongEditor extends React.Component
{
	constructor(props) {
		super(props);		
		this.state = {data:this.props.data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}

	
	getInputDom(_width)
	{
		let allowEdit = this.state.data.allowEdit;
		let _id = this.state.data.id;
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		if(allowEdit)
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,fontSize:"12px"}
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="text" 
			        	   className="form-control" style={_style} defaultValue={_defaultValue}/>;
		}
		else
		{	
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};		
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="text" readOnly="readonly"
			        	   className="form-control" style={_style} defaultValue={_defaultValue}/>;
		}
	}

	render()
	{
		let displayLength=this.state.data.displayLength;
		if(displayLength == 0)displayLength = FormItemConst.DISPLAYLENGTH_DATE_DEFAULT;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';

		let notNull=this.state.data.notNull;
		let _label = this.state.data.label;
		let _id = this.state.data.id;

		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		
		let inputdom = this.getInputDom(_width);
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		return(

			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
				<label htmlFor={"inputDialog"+_id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle}>
					{_label}
				</label>
				<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
				<div style={{position:"relative"}}>
					{inputdom}
			    </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldLongEditor.js